import React, { memo, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Collapse } from "reactstrap";
import "./lightTheme.scss";
const importDarktMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};
function InteractionComponent({ isRight, msg, isInformationTab, fields = [], isField = false, ...props }) {
  const { mainTheme } = useSelector((state) => state.Layout);
  importDarktMode(mainTheme);
  const [isOpen, setIsOpen] = React.useState(true);
  function toggle() {
    setIsOpen((prev) => !prev);
  }
  const { t } = useTranslation();


  const titleInteraction = useMemo(()=>{
    if(isInformationTab){
      return t("TabInfo");
    }

    if(isField){
      return t('Aditional Fields');
    }

    return t("Tab");
  },[isInformationTab, isField, t]);

  useEffect(() => {
    importDarktMode(mainTheme);
  }, [mainTheme]);
  if (!isRight) {
    return <></>;
  }
  

  return (
    <div
      className={`tabContainer d-flex ${
        isRight ? "justify-content-end" : "consumerLeft"
      }`}
      style={{ clear: "both" }}
    >
      <div className="content-tab">
        <div className="d-flex messageItem__header" onClick={toggle}>
          <div className="item-tab">
            <i className="bx bx-table" />
            <span>{titleInteraction}</span>
          </div>
          <div className="item-tab">
            <div>{t(isOpen ? "View Less" : "View More")}</div>
            {isOpen ? (
              <i className="bx bx-chevron-up" />
            ) : (
              <i className="bx bx-chevron-down" />
            )}
          </div>
        </div>
        <Collapse isOpen={isOpen}>
            <TabsOrFields
              fields={fields}
              isField={isField}
              msg={msg}
            />
        </Collapse>
      </div>
    </div>
  );
}
export default memo(InteractionComponent);

const TabsOrFields = ({fields=[], isField=false, msg})=>{

  const { t } = useTranslation();

  if(isField){
    return(
      <div className="content-items">
        {
          fields?.map((field, idx)=>(
            <div className="tab-item pt-1 pb-1" key={`field-tab-${idx}-${new Date()}`}>
              <div className="header">
                <div className="header-title">{field?.title}</div>
                <div className="header-name">{field?.text ?? '--'}</div>
              </div>
            </div>
          ))
        }        
      </div>
    );
  }

  return(
    <div className="content-items">
      {msg?.tabs?.[0] && (
        <div className="tab-item">
          <div className="header">
            <div className="header-title">{t("Level") + " 1"}</div>
            <div className="header-name">{msg?.tabs?.[0]?.tabName}</div>
          </div>
        </div>
      )}
      {msg?.tabs?.[1] && (
        <div className="tab-item">
          <div className="header">
            <div className="header-title">{t("Level") + " 2"}</div>
            <div className="header-name">{msg?.tabs?.[1]?.tabName}</div>
          </div>
        </div>
      )}
      {msg?.tabs?.[2] && (
        <div className="tab-item">
          <div className="header">
            <div className="header-title">{t("Level") + " 3"}</div>
            <div className="header-name">{msg?.tabs?.[2]?.tabName}</div>
          </div>
        </div>
      )}
    </div>   
  )

};
